<!-- src/components/CareerBanner.vue -->
<template>
  <div class="career-banner">
    <!-- 背景图 -->
    <div class="background-image"></div>
    
    <!-- 内容容器 -->
    <div class="content-container">
      <h1 class="main-title">
      
         {{ t("home.career.title") }}
       
      </h1>
      
      <p class="description">
         {{ t("home.career.description") }}
      </p>
      
      <div class="cta-button">
        <a href="mailto:hr@healthcodon.com">
        <button class="join-button">
         {{ t("home.career.joinUs") }}
        <div class="arrow-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-f316e37b=""><path d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.3334 12L7.66675 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </div>
        </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();
// 处理加入我们按钮点击事件
const handleJoinClick = () => {
  // 可以跳转到招聘页面或其他处理逻辑
  console.log('用户点击了加入我们按钮');
};
</script>

<style scoped>
.career-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../../assets/image/home/entry.png'); /* 需要替换为实际图片路径 */
  background-size: cover;
  background-position: center;
  filter: brightness(0.8) contrast(1.2);
  z-index: 1;
}
.arrow-icon{
  background: #0000004d;
  color: #fff;
}
.content-container {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 2rem;
  color: white;
  max-width: 800px;
  margin: 5rem auto;
}

.main-title {
  font-size: 2.6rem;
  line-height: 1.3;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.description {
  font-size: 1.3rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.cta-button {
  display: flex;
  justify-content: center;
}

.join-button {
  background-color: white;
  color: #333;
  border: none;
  border-radius: 24px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.join-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.arrow {
  font-size: 0.8rem;
  opacity: 0.8;
}

/* 响应式设计 */
@media (max-width: 768px) {

  
  .main-title {
    font-size: 2rem;
  }
  
  .description {
    font-size: 1rem;
  }
  
  .join-button {
    padding: 0.5rem 1rem;
  }
}
</style>